import React, { useEffect, useState, useRef } from "react";
import "./CustomerDashboard.css";
import { useNavigate } from "react-router-dom";
import totalOrdersIcon from "../assets/Total-orders.svg";
import openOrdersIcon from "../assets/calculator.svg";
import pendingOrdersIcon from "../assets/pending-orders.svg";
import approvedOrdersIcon from "../assets/approved-orders.svg";
import totalCostIcon from "../assets/total-order-cost.svg";
import DollarMoneyICon from "../assets/dollar-squareMoney.svg"
import axios from "../axiosSetup";
import { clearAuth, isAuthenticated, getUser } from "../auth";

export default function CustomerDashboard() {
  const [stats, setStats] = useState({
  totalOrders: 0,
  pendingOrders: 0,
  approvedOrders: 0,
  openOrders: 0,
  totalOpenOrderCost:0,
});

  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const user = getUser();

  // ✅ component-level guard (SAFE)
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    async function fetchDashboard() {
      try {
        if (!isAuthenticated()) {
          clearAuth();
          navigate("/login");
          return;
        }

        const res = await axios.get("/customer/dashboard");
        const data = res.data;

        setStats({
          totalOrders: data.totalOrders,
          pendingOrders: data.pendingOrders,
          approvedOrders: data.approvedOrders,
           openOrders: data.openOrders,
          totalOpenOrderCost: data.totalOpenOrderCost,
        });

        setRecentOrders(data.orders || []);
        setLoading(false);
      } catch (err) {
        if (err?.response?.status === 401) {
          clearAuth();
          navigate("/login");
        }
      }
    }

    fetchDashboard();
  }, [navigate]);

  const viewOrderDetails = (id) => {
    navigate(`/orders/view/${id}`);
  };

  if (loading) {
  return (
    <div className="dashboard-loader">
      <div className="spinner"></div>
      <p>Loading dashboard...</p>
    </div>
  );
}

 const formatMoney = (amount, currency) => {
  if (amount === undefined || amount === null) return `${currency || ""} 0.00`;

  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));

  return `${currency || ""} ${formatted}`;
};

  return (
    <div className="dashboard-container">
      <div className="greeting-row">
        <div className="greeting-left">
          <h2 className="greeting-text">Hello {user.name}</h2>
          <p className="email-text">Logged in as {user.email}</p>
        </div>

        <div className="customer-menu">
          {/* <button
    className="menu-btn"
    onClick={() => {
       window.open("https://www.google.com", "_blank", "noopener,noreferrer");
    }}
  >
    Returned Orders
  </button> */}
          <button
            className="menu-btn"
            onClick={() => navigate("/customer/orders")}
          >
            My Orders
          </button>
          <button
            className="menu-btn"
            onClick={() => navigate("/customer/price-listing")}
          >
            Price List
          </button>
        </div>
      </div>

      {/* ==================== Stats ==================== */}
      <div className="stats-grid">
        <div className="stat-card">
          <p className="cd-card-title">
            Open Orders
            <img src={totalOrdersIcon} alt="total orders" className="cd-card-icon" />
          </p>
          <h3>{stats.openOrders}</h3>
          <h6>All open orders</h6>
        </div>

        <div className="stat-card">
          <p className="cd-card-title">
            Pending Orders
            <img src={pendingOrdersIcon} alt="pending orders" className="cd-card-icon" />
          </p>
          <h3>{stats.pendingOrders}</h3>
          <h6>In progress</h6>
        </div>


        <div className="stat-card">
          <p className="cd-card-title">
            Approved Orders
            <img src={approvedOrdersIcon} alt="approved orders" className="cd-card-icon" />
          </p>
          <h3>{stats.approvedOrders}</h3>
          <h6>Approved</h6>
        </div>

        <div className="stat-card">
          <p className="cd-card-title">
            Total Open Order Cost
             <span className="currency-icon">
    {recentOrders?.[0]?.currency || ""}
  </span>
          </p>
          <h3>
            {formatMoney(stats.totalOpenOrderCost, recentOrders[0]?.currency || "")}
          </h3>
        </div>
      </div>

      {/* ==================== Recent Orders ==================== */}
      <div className="recent-orders-wrapper">
        <div className="recent-orders-header">
          <div className="recent-orders-title">
            <h3>Recent Orders</h3>
            <p>Your latest order activity</p>
          </div>
          <div className="recent-orders-actions">
          <button className="view-all-btn" onClick={() => navigate("/orders/add-order")}>
            Place Order
          </button>
          <button className="view-all-btn" onClick={() => navigate("/orders")}>
            View All Orders
          </button></div>
        </div>

        {recentOrders.length === 0 && <p>No recent orders</p>}

        {recentOrders.map((order) => {
          const formattedDate = new Date(order.createdAt).toLocaleDateString(
            "en-US",
            { year: "numeric", month: "long", day: "numeric" }
          );

          return (
            <div key={order.id} className="order-card">
              <div className="order-left">
                <div className="order-id-row">
                  <p className="order-id">Order #{order.id}</p>
                  <span className={`status-tag ${order.status?.toLowerCase()}`}>
                    {order.status.charAt(0) + order.status.slice(1).toLowerCase()}
                  </span>
                </div>
                <p className="order-date">{formattedDate}</p>
              </div>

              <div className="order-actions">
                <p className="order-price">
                  {formatMoney(order.total, order.currency)}
                </p>

                <button
                  className="details-btn"
                  onClick={() => viewOrderDetails(order.id)}
                >
                  View Details
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
